module.exports = __webpack_public_path__ + "img/job-heavy.9e33f9da.svg";